import styled from "styled-components";

export default styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;

    padding: 15px 0;

    .info {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        flex-grow: 1;

        padding: 0 15px;

        .name {
            display: flex;
            font-weight: bolder;
            letter-spacing: 0.1em;
            font-size: 16px;
            color: ${(props) => props.theme.homeListRowHeader};
        }

        .details {
            display: flex;
            flex-direction: row;
            margin: 0 -5px;

            .detail {
                display: flex;
                flex-direction: row;
                align-items: center;
                margin: 0 5px;

                p {
                    color: ${(props) => props.theme.homeListRowText};
                    font-size: 14px;
                }

                svg {
                    color: ${(props) => props.theme.homeListRowText};
                    font-size: 10px;
                    margin-right: 4px;
                    margin-bottom: 2px;
                }
            }
        }
    }

    .date {
        display: flex;
        color: ${(props) => props.theme.homeListRowText};
        font-size: 14px;
        margin: 0 20px;
    }

    .actions {
        cursor: pointer;
        min-width: 40px;

        svg {
            font-size: 20px;
            color: ${(props) => props.theme.tableIconHighlight};
        }
    }

    :hover {
        background-color: ${(props) => props.theme.homeListBodyBackgroundHover};
    }
`;
